// extracted by mini-css-extract-plugin
module.exports = {"root":"AudioPlayer_root__ug9aX","caption":"AudioPlayer_caption__qWang","player":"AudioPlayer_player__pWTMV","withImage":"AudioPlayer_withImage__L7O_R"};